export default {
    title: 'Nutzer',
    id: 'ID',
    customName: 'Anzeigename',
    user_email: 'E-Mail',
    role_name_de: 'Rolle'
}